import { type FC } from 'react';

import styles from './PromoBlackFridayBadge.css';

interface IPromoBlackFridayBadgeProps {
  size: number;
}

export const PromoBlackFridayBadge: FC<IPromoBlackFridayBadgeProps> = ({ size }) => {
  const style = {
    height: `${size}px`,
    width: `${size}px`,
  };

  return <div className={styles['container']} style={style} />;
};
